<ca-modal-confirm
    title="{{ 'GENERAL.CONFIRMATION' | translate }}"
    message="{{ deleteMessage }}"
    confirmText="{{ 'GENERAL.DELETE' | translate }}"
></ca-modal-confirm>
